import { Injectable, inject } from '@angular/core';
import { TimeBlockHttpService } from '../../../state/time-blocks/time-block-entries/time-block-http.service';
import { ProjectModel } from '../../../models/project/project.model';
import { ProjectDataService } from '../../../../pages/project/project-details/state-and-data-handling/project-data.service';
import { map, take } from 'rxjs/operators';
import { TimeBlockProjectModel } from '../../../models/timeblock/time-block.model';
import { TimeBlockWithTask } from '../../../../shared/data-types/shared-time-block-types';
import { Observable } from 'rxjs';
import { TimeBlockFilterService } from '../time-tracking/time-block-filter.service';

@Injectable({
  providedIn: 'root',
})
export class SharedTaskHandlerService {
  private readonly timeBlockHttpService = inject(TimeBlockHttpService);
  private readonly projectDataService = inject(ProjectDataService);

  public fetchTimeBlocksWithTasks(
    project: ProjectModel,
    sort: boolean,
    isInvoiced: boolean | null,
    includeActiveTimeBlock: boolean,
    isBillable: boolean | null,
    removeNonWorkingTimeBlocks = true,
  ): Observable<TimeBlockWithTask[]> {
    const tasks = this.projectDataService.getTasks(project, isBillable, false);
    const taskById = new Map(tasks.map((t) => [t.id, t]));

    return this.timeBlockHttpService
      .fetchTimeBlocksForTasks(
        tasks.map((t) => t.id),
        isInvoiced,
        includeActiveTimeBlock,
      )
      .pipe(
        take(1),
        map((timeBlocks) => {
          if (removeNonWorkingTimeBlocks) {
            timeBlocks = TimeBlockFilterService.removeNonWorkingTimeTimeBlocks(timeBlocks);
          }
          const blocks = sort
            ? [...timeBlocks].sort(
                (a, b) =>
                  new Date(a.timeBlockModel.start).getTime() -
                  new Date(b.timeBlockModel.start).getTime(),
              )
            : timeBlocks;

          return blocks.map(
            (timeBlock) =>
              ({
                timeBlock,
                task: taskById.get((timeBlock.timeBlockModel as TimeBlockProjectModel).task.id),
              }) as TimeBlockWithTask,
          );
        }),
      );
  }
}
